import ServiceRegistry from '@/service/registry/ServiceRegistry'

/**
 * Base service class. Used to define service objects
 * managed by the ServiceRegistry.
 */
export class ServiceInjector extends Object {
  static injectedName () {
    throw Error('Static function injectedName is not defined')
  }

  /**
   * This is a required getter method used as the default export on all services.
   * The static provider function will inject the service into the ServiceRegistry
   * if it does not exist. This provides the service as an Vue.observable Object
   * to be injected into any component.
   * @returns {string}
   */
  static get provider () {
    ServiceRegistry.registerInjectableService(this)
    return this.injectedName()
  }

  /**
   * Locks the instance of a Service so so it is sealed
   * and not extendable
   * @returns {ServiceInjector}
   */
  get lock () {
    Object.seal(this)
    return this
  }
}
